import { PauseCircleOutlined } from '@ant-design/icons'
import { Flex, Tag } from 'antd'
import { FC } from 'react'
import RewindQueueEntry from '../../../../../types/api/rewind-queue-entry'
import { isRewindJobPaused } from '../helpers/rewind-job-helpers'
import FinishRewind from './finish-rewind'
import StartRewind from './start-rewind'
import CancelRewind from './cancel-rewind'

interface ActionsCellProps {
    rewindQueueEntry: RewindQueueEntry
}

const ActionsCell: FC<ActionsCellProps> = ({ rewindQueueEntry }) => {
    const isPaused = isRewindJobPaused(rewindQueueEntry.rewind_job)

    return (
        <Flex gap={8} align='center' wrap='wrap'>
            {isPaused && (
                <Tag icon={<PauseCircleOutlined />} color='warning' style={{ margin: 0 }}>
                    Пауза
                </Tag>
            )}
            <StartRewind rewindQueueEntry={rewindQueueEntry} />
            <FinishRewind rewindQueueEntry={rewindQueueEntry} />
            <CancelRewind rewindQueueEntry={rewindQueueEntry} />
        </Flex>
    )
}

export default ActionsCell
